import React, { useState } from "react";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import { checkIsArrayEmpty } from "features/Common/modules/DataTypes/utils/Array.utils";
import { ExlyDropdown } from "common/form";

export const OrgSelectModal = withComponentLibraryTheme(
  ({ profiles, setProfiles, onProfileSelect }) => {
    const [selectedUsername, setSelectedUsername] = useState("");

    if (!checkIsArrayEmpty(profiles) && profiles.length > 1) {
      return (
        <ExlyModal
          primaryBtnText="Confirm"
          title={
            <div className={`mr-4`}>
              Choose the organisation you&apos;d like to log in with
            </div>
          }
          onClose={() => setProfiles([])}
          onPrimaryBtnClick={() => {
            onProfileSelect({ creator_username: selectedUsername });
          }}
          open
        >
          <div className={`py-2`}>
            <ExlyDropdown
              fullWidth
              placeholder="Select organistion"
              size="medium"
              options={profiles.map((item) => ({
                ...item,
                value: item.username,
                label:
                  item.hostsite_url ??
                  `${item.sub_domain}.${process.env.REACT_APP_PROJECT_DOMAIN}`,
              }))}
              input={{
                onChange: (value) => {
                  setSelectedUsername(value);
                },
                value: selectedUsername,
              }}
              validate={(value) => !value && "Please choose a organistaion"}
            />
          </div>
        </ExlyModal>
      );
    }

    return <></>;
  }
);
